module.exports = __webpack_public_path__ + "img/colombia.c6a7ff3.webp";